import React from 'react';
import { LazySection } from './LazySection';
export function SocialProof() {
  return <LazySection className="bg-ink text-cream !py-[60px]" data-id="element-291">
      <div className="container-wide" data-id="element-292">
        <div className="text-center mb-10" data-id="element-293">
          <h3 className="text-[22px] mb-2 text-cream font-serif" data-id="element-294">
            Un sistema completo. No un ebook más.
          </h3>
          <p className="text-cream/70 text-base max-w-[600px] mx-auto" data-id="element-295">
            Material operativo para trabajar la{' '}
            <span className="highlight-keyword-light" data-id="element-296">raíz</span> — no teoría,
            no afirmaciones, no más de lo mismo.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-[30px] max-w-[900px] mx-auto mb-[50px]" data-id="element-297">
          <div className="text-center" data-id="element-298">
            <div className="font-serif text-[clamp(38px,5vw,56px)] text-gold-light font-medium leading-none mb-2" data-id="element-299">
              6
            </div>
            <div className="text-[13px] text-cream/70 tracking-[0.03em] leading-snug" data-id="element-300">
              módulos del sistema
            </div>
          </div>
          <div className="text-center" data-id="element-301">
            <div className="font-serif text-[clamp(38px,5vw,56px)] text-gold-light font-medium leading-none mb-2" data-id="element-302">
              3
            </div>
            <div className="text-[13px] text-cream/70 tracking-[0.03em] leading-snug" data-id="element-303">
              generaciones que trazás
            </div>
          </div>
          <div className="text-center" data-id="element-304">
            <div className="font-serif text-[clamp(38px,5vw,56px)] text-gold-light font-medium leading-none mb-2" data-id="element-305">
              +40
            </div>
            <div className="text-[13px] text-cream/70 tracking-[0.03em] leading-snug" data-id="element-306">
              ejercicios guiados
            </div>
          </div>
          <div className="text-center" data-id="element-307">
            <div className="font-serif text-[clamp(38px,5vw,56px)] text-gold-light font-medium leading-none mb-2" data-id="element-308">
              2
            </div>
            <div className="text-[13px] text-cream/70 tracking-[0.03em] leading-snug" data-id="element-309">
              estudios científicos
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 max-w-[1080px] mx-auto" data-id="element-310">
          <div className="bg-white/5 border border-cream/10 rounded-[14px] p-6" data-id="element-311">
            <div className="text-gold-light text-sm tracking-[2px] mb-3" data-id="element-312">
              ★ ★ ★ ★ ★
            </div>
            <p className="font-serif italic text-cream text-base leading-relaxed mb-3.5" data-id="element-313">
              "Ponerle nombre al{' '}
              <span className="highlight-keyword-light" data-id="element-314">patrón</span> fue el
              primer paso de mi liberación."
            </p>
            <div className="text-xs text-cream/55 tracking-[0.02em]" data-id="element-315">
              <strong className="text-gold-light font-medium" data-id="element-316">
                Review verificada
              </strong>{' '}
              · Amazon — libro de psicología transgeneracional
            </div>
          </div>

          <div className="bg-white/5 border border-cream/10 rounded-[14px] p-6" data-id="element-317">
            <div className="text-gold-light text-sm tracking-[2px] mb-3" data-id="element-318">
              ★ ★ ★ ★ ★
            </div>
            <p className="font-serif italic text-cream text-base leading-relaxed mb-3.5" data-id="element-319">
              "Cuando entendí que no era mío, algo se alivió en mí. No era culpa
              mía."
            </p>
            <div className="text-xs text-cream/55 tracking-[0.02em]" data-id="element-320">
              <strong className="text-gold-light font-medium" data-id="element-321">
                Testimonio
              </strong>{' '}
              · Foro de psicología en español
            </div>
          </div>

          <div className="bg-white/5 border border-cream/10 rounded-[14px] p-6" data-id="element-322">
            <div className="text-gold-light text-sm tracking-[2px] mb-3" data-id="element-323">
              ★ ★ ★ ★ ★
            </div>
            <p className="font-serif italic text-cream text-base leading-relaxed mb-3.5" data-id="element-324">
              "Llevo dos años en terapia y sigo eligiendo lo mismo. Nadie me
              explicó que podía ser algo que venía de antes de mí."
            </p>
            <div className="text-xs text-cream/55 tracking-[0.02em]" data-id="element-325">
              <strong className="text-gold-light font-medium" data-id="element-326">
                Testimonio citado
              </strong>{' '}
              · Nelaosorio.es
            </div>
          </div>
        </div>
      </div>
    </LazySection>;
}